<div style="text-align: left">
{{currentValue}}
</div>